import { useCallback, useState } from "react"
import { useAuth } from "@clerk/clerk-react"
import { useDemoMode } from "../demo/DemoProvider"
import { requestStripeConnectLink } from "../api/onboarding"

export function useConnectStripe() {
  const { demo } = useDemoMode()
  const { getToken } = useAuth()
  const [connecting, setConnecting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const connect = useCallback(async () => {
    setConnecting(true)
    setError(null)
    try {
      const token = await getToken()
      if (!token && !demo) {
        throw new Error("Not authenticated")
      }
      const url = await requestStripeConnectLink(demo, token ?? undefined)
      window.location.href = url
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to connect Stripe")
      setConnecting(false)
    }
  }, [demo, getToken])

  return { connect, connecting, error }
}
